export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5333.56b0e043.jpg";